import { useParams } from 'react-router-dom';
import BorderedButton from '../../components/common/buttons/BorderedButton';
import GradientCircularProgress from '../../components/common/GradientCircularProgress';
import useDownloadResult from '../../hooks/useDownloadResult';
import { useThemeContext } from '../../contexts/BaseThemeContextProvider';

const backendURL = process.env.REACT_APP_BACKEND_URL;

type DownloadPDFReportResultsProps = {
  reportData: {
    test_name: string;
    sample_id: string;
  };
};

const DownloadPDFReportResults = ({ reportData }: DownloadPDFReportResultsProps) => {
  const { theme } = useThemeContext();
  const { id } = useParams<{ id: string }>();
  const resultDownloadUrl = `${backendURL}/reports/${id}/pdf`;

  const { isResultDownloading, error, handleDownloadClick, userResultData } = useDownloadResult(
    resultDownloadUrl,
    reportData?.test_name,
    reportData?.sample_id,
  );

  const renderDownloadResultBtn = () => {
    if (isResultDownloading) {
      return (
        <GradientCircularProgress
          loadingMessage=""
          additionalCircularSxProps={{
            width: '30px !important',
            height: '30px !important',
            marginTop: '-14px',
            mr: '10px',
          }}
        />
      );
    }

    if (error || !userResultData) {
      return <></>;
    }

    return (
      <BorderedButton
        sxProps={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          alignSelf: 'stretch',
          width: 'auto',
          marginLeft: 'auto',
          padding: 0,
          marginTop: '12px',
          '@media (max-width: 400px)': {
            width: '100%',
          },
        }}
        additionalProps={{
          style: {
            border: 'none',
            height: '18px',
            color: theme.custom.report.details.downloadPDFResult.buttons.ghost.color,
          },
          startIcon: (
            <img
              src={theme.custom.report.details.downloadPDFResult.images.download.src}
              alt={'View results'}
              style={{ width: '18px', height: '18px' }}
            />
          ),
        }}
        onClick={handleDownloadClick}
        buttonText="Download PDF"
      />
    );
  };

  return renderDownloadResultBtn();
};

export default DownloadPDFReportResults;
